<template lang="pug">
	header(:class="{'scroll-down-fade': hideOnScroll}")
		b-container.d-print-none#v-2(fluid)
			b-navbar(toggleable="lg" v-bind:class="{'menuFixed' : menuFixed}")
				a(ref="savingsCenterModalMenuButton" v-b-modal.sfc-college-savings-questions-modal)
				.nav-row(@mouseleave="hideMyDiv()")
					b-row
						b-col
							.collapses
								b-navbar-brand(href="/" @mouseenter="hideMyDiv()") SavingForCollege

								b-collapse#nav_collapse(is-nav="")
									b-navbar-nav.main-links#main-linkage(justified)
										span.nav-linkage(v-for="(menu, index) of $store.state.menu" :key="menu.menu_link_id")
											b-nav-item(:href="menu.url" @mouseenter="showMyDiv(index)" @click="trackAction('Menu Navigation Click', {'title': `${menu.name}`})")
												| {{menu.name}}
											.dropdown-row(v-if="menu.children.length > 0")
												.dropdown-menu-items(:id="`dropdown${index}`")
													span.nav-arrow
														span.nav-arrow-border
													b-row
														b-col(cols="12")
															b-dropdown-item(v-for="menuItem of menu.children" :href="menuItem.url" @click="trackAction('Menu Navigation Click', {'title': `${menuItem.name}`})" :key="menuItem.menu_link_id" :class="{'nested': !menuItem.is_direct_child}" v-if="menuItem.menu_link_id != 100")
																| {{menuItem.name}}
																span.tag.pro(v-if="menuItem.is_pro")
																	| PRO
															no-ssr
																b-dropdown-item(href="/subscriptions/cancel.php" @click="trackAction('Menu Navigation Click', {'title': 'Cancel subscription'})" v-if="$store.state.userIsLoggedIn && index == 4")
																	| Cancel subscription
							.non-collapse
								ul
									li.d-none.d-sm-block
										a.btn.start-saving(@click="openSavingsCenter();trackAction('Savings Center Navigation', 'Header menu click')" @mouseenter="hideMyDiv()")
											span(:class="{'button-with-spinner':loadingSavingsCenterUser}") Savings Center
											span.spinner.menu-savings-center-spinner(v-if="loadingSavingsCenterUser")
												spinner(size="13")
									li
										no-ssr
											span(v-if="$store.state.userIsLoggedIn")
												span.d-none.d-lg-inline
													.login
														a(@mouseenter="showMyDiv(12)")
															| Account
														.dropdown-row
															.dropdown-menu-items#dropdown12
																span.nav-arrow
																	span.nav-arrow-border
																.row
																	.col-12
																		a(href="/manage_account/") Manage Account
																		a(:href="logoutUrl") Log out
											span(v-else)
												span.d-none.d-lg-inline
													.login
														a(@mouseenter="showMyDiv(13)")
															| Login
														.dropdown-row
															.dropdown-menu-items#dropdown13
																span.nav-arrow
																	span.nav-arrow-border
																.row
																	.col-12
																		a(@click="openLogin") Advisor
																		a(href="/savings-center/login") Personal
												//- span.d-none.d-lg-inline
												//- 	.login.login-adjust(@click="openLogin" @mouseenter="hideMyDiv()")
												//- 		| Log In
									li.d-none.d-sm-block.nav-search
										.search-icon(@click="searchOpen()")



</template>

<style lang="stylus">
	.menu-savings-center-spinner
		display: inline-block
</style>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	@media print
		.navbar
		header
			position: relative!important

	@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)
		.dropdown-menu-items
			min-width: 250px
		#dropdown0
			min-width: 380px
		#dropdown1
			min-width: 278px
		#dropdown2
			min-width: 415px
		#dropdown4
			min-width: 338px
	.flex
		display: flex

	.original
		.navbar-brand
			height: 35px
			width: 125px

	nav.navbar
		display: block
		padding: 0
		.navbar-toggler
			background: sfc-blue-dark!important
			opacity: 0.9
			top: 10px
			padding: 0
		.nav-row
			background sfc-blue-dark
			border-bottom: sfc-blue-dark-border 1px solid
			height: 60px
		a.navbar-brand
			background: url('https://web-resources.savingforcollege.com/images/logo-on-blue.svg') no-repeat
			background-size: contain
			display: inline-block
			cursor: pointer
			position: relative
			text-indent: -999999px
			float: left
			margin: -10px 6px 0 6px
			@media (max-width: 576px)
				margin: 6px auto
				display: block
				float: none
		.collapses
			width: calc(100% - 260px)
			display: inline-flex
			position: relative
			vertical-align: middle
			@media (max-width: 992px)
				width: calc(100% - 195px)
			@media (max-width: 576px)
				width: 100%
				display: block
			.navbar-toggler
				border: 0px solid #fff !important
				border-right: 1px solid #3976b2
				top: 12px
				position: absolute
				right: 0
				@media (max-width: 576px)
					top: 0
				.navbar-toggler-icon
					background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(71,181,247,1)'")
				span
					width: 22px
					display: block
					clear: both
					background rgba(71,181,247,1)
					margin: 5px
					height: 2px
					box-shadow: 0 2px 6px 0 rgba(39, 56, 77, 0.1)
					position: relative
					transition-all()
				&[aria-expanded="true"]
					span
						&.first
							transform: rotate(45deg)
							top: 5px
						&.middle
							opacity: 0
						&.last
							transform: rotate(-45deg);
							top: -9px

		.non-collapse
			width: 260px
			display: inline-flex
			@media (max-width: 992px)
				width: 195px
			@media (max-width: 576px)
				display: none

			ul
				padding: 0
				margin: 0
				li
					float: left
					margin: 15px 0
					color: #fff

					.login
						top: 5px
						cursor: pointer
						font-weight: body-font-weight
						position: relative
				> span
					display: inline-block

		ul.navbar-nav
		.non-collapse
			vertical-align: middle
			position: relative
			.nav-search
				padding: 0
				height: 30px
				a
					height: 25px
			li
				font-size: body-font-size-xs
				text-align: center
				text-transform: capitalized
				position: relative
				vertical-align: middle
				display: inline-block
				margin: 15px
				a
					color: #fff
					padding: 0px
					position: relative
					bottom: -1px
					height: 100%
					border-bottom: 2px solid sfc-blue-dark
					cursor: pointer
					text-decoration: none
					&:hover
						border-bottom: 2px solid sfc-pale-yellow
						color: sfc-pale-yellow
				&.active
					a
						border-bottom: 2px solid sfc-pale-yellow
						color: sfc-pale-yellow
				&.search
					a
						border-bottom: 0px
						&:hover
							border-bottom: 0px
				a.btn
					padding: 8px 15px!important
					height: auto!important
					text-transform: none!important
					margin: 0!important
					&:hover
						color: #fff!important
			&.main-links
				width: 100%
				li
					margin: 15px 0
					a
						display: unset
						padding-bottom: 5px

						&:hover
							color: sfc-pale-yellow !important



	.scroll-down-fade
		-webkit-transform translateY(-100%)
		transform translateY(-100%)
	.navbar-toggler
		top: 7px!important

	.spinner
		margin: 0 !important

	.button-with-spinner
		top: -2px
		position: relative
		margin-right: 6px

	span.sc
		padding: 0 10px!important
		display: inline-block
		border-left: 1px solid #3976b2
		height: 20px
		padding-left: 25px!important
		position: relative
		top: 6px
		a.savings-center
			bottom: 3px!important
			font-size: body-font-size-sm
			&.active
			&:hover
				text-decoration: none
				border-bottom: 2px solid #ffc564!important
				color: #ffc564!important

	a.start-saving
		border: 1px solid #073D71!important
		background: sfc-blue !important
		font-weight: body-font-weight
		font-size: body-font-size-xs!important
		color: #fff !important
	header
		position: relative
		top: 0
		width: 100%
		z-index: 1010
		transition(transform, .8s, ease-in-out)
		> .container-fluid
			padding: 0
		a.navbar-brand
			height: 40px
			width: 140px
			@media screen and (max-width: 576px)
				height: 45px
				width: 150px

	ul.main-links
		span.nav-linkage
			width: 20%
			display: inline-block
			position: relative
			text-align: center
			vertical-align: middle
			text-decoration: none
			&:hover
				li
					a.nav-link
						border-bottom: 2px solid #ffc564!important
						color: #ffc564!important

			li
				margin: 0!important
			&:first-child
				width: 16%
			&:nth-child(2)
			&:nth-child(3)
				width: 22%
		li
			width: 100%
			a
				font-size: body-font-size-sm
				display: block
				width: 100%
				padding: 0!important


	nav.navbar
		&.menuFixed
			position: fixed
			#nav_mobile
				padding: 30px 30px

	#nav_mobile
		transition-all()
		padding: 0px 30px
		.section
			ul
				max-height: 0px
				overflow: hidden
				transition-all()
			&.show
				span.arrow-down
					border-top: 7px solid #000
					transform: rotate(180deg)
				ul
					max-height: 1000px
					overflow: scroll
		.dd-title

			font-size: body-font-size-lg
			position: relative
			margin-bottom: 10px
			span.arrow-down
				transition-all()
			&:hover
				cursor: pointer
				span.arrow-down
					border-top: 7px solid #000

		ul
			list-style: none
			padding-left: 30px
			li
				border-left: 2px solid rgba(206, 211, 225, 0.3)
				a
					padding: 7.5px 0
					padding-left: 15px
					display: block
					&:hover
						text-decoration: none
				&:hover
					border-left: 2px solid sfc-blue-link
					a
						color: sfc-blue-link
						text-decoration: none

	#dropdown-search-row
		> .container
			position: relative
			z-index: 31
			min-width: 300px

	#dropdown7
		display: none
		position: absolute
		right: 0
		width: 400px
		z-index: 31
		background: bg-gray
		border: 1px solid sfc-pale-gray
		&.show
			display: block!important

	.nav-row
		background: sfc-blue-dark
		.dropdown-row
			background: transparent
			max-width: none
			width: auto !important
			position: absolute
			z-index: 101
			padding-top: 30px
			top: 35px
			.nav-arrow
				width: 0
				height: 0
				display: block
				border-left: 8px solid transparent
				border-right: 8px solid transparent
				border-bottom: 8px solid sfc-pale-gray
				position: absolute
				display: block
				margin-left: 15px
				top: 23px
			.nav-arrow-border
				width: 0
				height: 0
				display: block
				border-left: 7px solid transparent
				border-right: 7px solid transparent
				border-bottom: 7px solid #fff
				position: absolute
				top: 1px
				left: -7px
				display: block
			.dropdown-menu-items
				background: #fff
				border: 1px solid sfc-pale-gray
				box-shadow()
				width: 100%
				display: none
				padding: 30px
				&.show
					display: block!important
				.dropdown-header
					text-transform: uppercase
					font-size: body-font-size-sm
				.dropdown-item
					padding: 0
					color: body-font-color
				a
					text-transform: none
					display: block!important
					border-bottom: 0px solid!important
					padding: 7.5px 15px!important
					border-left: 2px solid rgba(206, 211, 225, 0.3)
					text-align: left!important
					height: auto!important
					text-decoration: none
					&:hover
						border-left: 2px solid sfc-blue-link
						background: transparent
						color: sfc-blue-link!important
					&.nested
						padding-left: 45px !important
					span.tag.pro
						margin-left: 5px
						background: red-pop
						border: 1px solid red-border
						font-size: body-font-size-xxs
						padding: 9px 8px !important
						font-weight: body-font-weight-strong
						color: #fff
						display: inline-block
						vertical-align: middle

	.nav-search
		position: relative
		background-repeat: no-repeat
		display: inline-block
		float: right
		width: 35px
		padding: 15px
		background-size: 30%
		background-position: center center
		background-repeat: no-repeat
		cursor: pointer
		.search-icon
			background-image: url('//web-resources.savingforcollege.com/images/icon-search-white.svg')
			background-repeat: no-repeat
			right: 0
			background-size: contain
			height: 14px
			width: 14px
			display: block
			position: absolute
			opacity: 1
			transition-all()
			top: 10px
			&:hover
				opacity: 0.5

		.tb.search.desktop
			display: block
			top: -5px
			position: absolute
			margin: 0
			right: 0
			width: 0px
			overflow: hidden
			transition-all()
			opacity: 0
			height: 50px
			input
				border-bottom: 1px solid #3976b2
				padding-right: 15px
			.search-icon
				background-image: url('//web-resources.savingforcollege.com/images/icon-search-white.svg')
				background-repeat: no-repeat
				left: 0px
				background-size: contain
				height: 14px
				width: 14px
				opacity: 0
				position: absolute
				transition-all()
				top: -3px
			&.open
				width: 244px
				opacity: 1
				background: sfc-blue-dark
				.search-icon
					opacity: 1
				label
					padding-left: 15px
					margin-left: 0px
			.close
				cursor: pointer
				position: absolute
				right: 0px
				z-index: 999
				top: 3px
				text-shadow: none
				font-size: body-font-size
				opacity: 1
				color: #3976b2
				transition-all()
				svg
					height: 10px
					width: 10px
					display: block
					.filler
						transition-all()
						fill: #3976b2
				&:hover
					svg
						.filler
							fill: #fff

			input
				background: transparent
				padding: 5px 0
				padding-right: 15px
				font-size: body-font-size-sm
				padding-left: 25px
				color: #fff
			.tb-end
				display: none

	.nav-row
	.head-row
		> .row
			max-width: 1170px
			width: 100%
			margin: 0 auto

	.login
		min-width: 65px
		top: 8px!important
		font-size: body-font-size-sm
		position: relative
		.dropdown-row
			right: 0!important
			width: 220px!important
			.nav-arrow
				right: 25px!important
			a
				color: body-font-color !important
				&:hover
					color: sfc-blue!important
		a
			text-decoration: none!important
			top: auto!important
			&:hover
				text-decoration: none
				border-bottom: 2px solid #ffc564!important
				color: #ffc564!important

	.login-adjust
		top: 12px!important

	#top-banner
		height: 90px
		width: 728px
		float: right
		margin: 15px auto
		display: inline-block

	.mobile-nav
		width: 100%
		position: fixed
		overflow: scroll
		height: auto
		transition-all()
		z-index: 999
		border-right: 1px solid sfc-pale-gray
		.mobile-login
			margin: 0 auto
			.modal-dialog
				margin: 0 auto
			> div
				cursor: pointer
				> span
					text-align: right
					display: block
					font-size: body-font-size-lg

				&:hover
					> span
						color: sfc-blue-link
		#link-list
			opacity: 1
			transition-all()
			span.arrow-down
				right: 0
			&.search-focused
				opacity: 0
			.nested
				a
					padding-left: 30px !important

	.tb.search-mobile
		max-width: 400px
		margin: 0 auto
		margin-bottom: 30px
		transition-all()
		position: relative
		label
			margin: 10px
		.search-icon
			background-image: url('//web-resources.savingforcollege.com/images/icon-search-gray.svg')
			background-repeat: no-repeat
			left: 0
			background-size: contain
			height: 14px
			width: 14px
			display: block
			position: absolute
			top: 15px
		.tb-end
			position: absolute
			display: none
			right: 15px
			top: 3px
			font-size: body-font-size-xxs!important
			text-transform: uppercase
		input
			display: inline-block!important
			width: 93%!important
			padding: 10px 15px
			padding-left: 30px
			transition-all()
			&:focus
				color: sfc-blue-link
				border-bottom: 1px solid sfc-blue-link
				padding-right: 95px
				display: inline-block!important
			&:focus +
				.tb-end
					display: block!important
					color: sfc-blue-link
		&.focused
			z-index: 999
			background: #fff

	@media screen and (max-width: 992px)
		.menuFixed
			height: 100%
		.navbar
			width:100%
			overflow: auto
			z-index: 900
			left: 0
		.nav-row
			border-bottom: 0px solid #fff!important

	@media screen and (min-width: 576px) and (max-width: 992px)
		.mobile-nav
			top: auto
			margin-top: 61px
	@media screen and (min-width: 576px) and (max-width: 992px)
		.navbar-toggler
			top: 12px!important
		.menuFixed
			.nav-row
				border-bottom: 1px solid #fff!important
			.mobile-nav
				height: auto

				#nav_mobile
					border-bottom: 1px solid sfc-pale-gray
		.banner-callout
			.ratings
				.cap-rating
					width: 145px!important
	@media screen and (max-width: 576px)
		.nav-row
			> .row
				margin: 0
				> .col
					padding: 0
		.mobile-nav
			margin: 0
			overflow: scroll
			#nav_mobile
				border-bottom: 1px solid sfc-pale-gray
		.menuFixed
			.mobile-nav
				height: 100%
	@media screen and (min-width: 577px) and (max-width: 991px)
		.nav-row
			> .row
				margin: 0
				> .col
					padding: 0
		.mobile-nav
			margin-top: 58px
			width: 102%
			overflow: scroll
			#nav_mobile
				border-bottom: 1px solid sfc-pale-gray
		.menuFixed
			.mobile-nav
				height: 100%
</style>


<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'

	export default {

		data() {
			return {
				menuItems: [{tab: 1},{tab: 2}],
				windowWidth: 0,
				windowHeight: 0,
				searchFor: '',
				pageUrl: '',
				menuTimeout: undefined,
				searchBoxOpened: false,
				changeMenuImmediately: false,
				menuFixed: false,
				loadingSavingsCenterUser: false,
				hideOnScroll: false,
				blockTimeout: false,
				savingsCenterFlow: false,
				logoutUrl: '/logout/'
			}
		},
		components:{
			Spinner
		},

		mounted() {
			this.$nextTick(function() {
				window.addEventListener('resize', this.getWindowWidth);
				window.addEventListener('resize', this.getWindowHeight);

				this.getWindowWidth()
				this.getWindowHeight()

			})

			this.logoutUrl = `/logout/?return_url=${window.location.href}`

		},
		watch: {
			windowWidth(newWidth, oldWidth) {

				let mainLayout;
				mainLayout = document.getElementById('__layout');


				if (newWidth > 991){
					mainLayout.classList.remove('fixed')
				}
			}
		},

		methods: {

			openLogin(){
				window.location.href = '/login'
			},
			obModalShow(){
				this.savingsCenterFlow = false
			},

			userIsLoggedIn(){
				return true
			},
			trackAction(eventDescription, additionalInformation = false){
				SfcTrackingService.trackAction(eventDescription, "Navigation", "2", additionalInformation)
			},

			async nextStep(){
				let token = this.$cookies.get("sfc_primary")
				let collegeSavingsUser = undefined

				if (token){
					if (this.$store.state.collegeSavingsUserOnboarding  && this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]){
						return "/savings-center/" + this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
					}
				}
				else{
					return false
				}

				const query = `
					query{
						no_graphql_cache()
						college_savings_user_v3(sfc_token: "${token}"){
							id
							next_step_v3
							type_of_user
							children{
								id
								name
								age
							}
							state{
								id
								name
								slug
							}
							email
							primary_id
						}
					}
				`

				this.loading = true
				try {
					let result = await this.$httpService.graphql(query)
					collegeSavingsUser = result.data.college_savings_user_v3
				} catch (e) {
					collegeSavingsUser = undefined
				}
				this.loading = false

				if(!collegeSavingsUser)	return false

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: collegeSavingsUser.next_step_v3})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: collegeSavingsUser.type_of_user})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "children", value: collegeSavingsUser.children})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: collegeSavingsUser.state})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: collegeSavingsUser.email})

				return "/savings-center/" + collegeSavingsUser.next_step_v3
			},

			async openSavingsCenter(){
				let nextPageUrl = false

				// this.savingsCenterFlow = true

				nextPageUrl = await this.nextStep()

				if(nextPageUrl){
					window.location.href = nextPageUrl
				}else{
					setTimeout(()=>{
						this.$sfcModal.open("sfc-onboarding-modal-v3-2", {savingsCenterFlow: true})
					},0)
				}
			},
			fixMenu(){
				this.menuFixed = !this.menuFixed;
				let mainLayout;
				mainLayout = document.getElementById('__layout');
				mainLayout.classList.toggle('fixed')
			},
			searchOpen(){
				window.location.href="/search"
			},
			searchClose(){
				this.searchBoxOpened = false
				this.searchFor = ""
			},
			setFocus(){
				let mobileFocusDiv;
				let mobileLinkList;
				mobileFocusDiv = document.getElementById('mobile-focus');
				mobileLinkList = document.getElementById('link-list');

				mobileLinkList.classList.add("search-focused");
				mobileFocusDiv.classList.add("focused");
			},
			unFocus(){
				let mobileFocusDiv;
				let mobileLinkList;
				mobileFocusDiv = document.getElementById('mobile-focus');
				mobileLinkList = document.getElementById('link-list');

				mobileLinkList.classList.remove("search-focused");

				mobileFocusDiv.classList.remove("focused");
			},
			getWindowWidth(event) {
					this.windowWidth = document.documentElement.clientWidth;
			},

			getWindowHeight(event) {
				this.windowHeight = document.documentElement.clientHeight;
			},
			hideMyDiv(resetTrigger = true) {
				if(resetTrigger){
					this.changeMenuImmediately = false
				}
				clearTimeout(this.menuTimeout)
				const allDropdowns = document.getElementsByClassName('dropdown-menu-items');
				for(var i = 0; i < allDropdowns.length; i++){
					allDropdowns[i].classList.remove("show");
				}
			},
			showMyDiv(event) {

				clearTimeout(this.menuTimeout)

				if(this.changeMenuImmediately){
					this.changeMenuImmediately = true
					this.hideMyDiv(false)
					let currentDropdown
					currentDropdown = document.getElementById('dropdown' + event);
					currentDropdown.classList.add("show");
				}else{
					this.menuTimeout = setTimeout(() => {
						this.changeMenuImmediately = true
						this.hideMyDiv(false)
						let currentDropdown
						currentDropdown = document.getElementById('dropdown' + event);
						currentDropdown.classList.add("show");
					}, 500)
				}
			},
			showDiv(event) {
				let currentDropdown
				let allDropdowns
				allDropdowns = document.getElementsByClassName('nav-section');
				currentDropdown = document.getElementById('mobile-dd' + event);


				for (var i = 0; i < allDropdowns.length; i++) {
					if (allDropdowns[i].classList.contains('show')){
						allDropdowns[i].classList.remove('show')
					}
				}

				setTimeout(() => {
					if (currentDropdown.classList.contains('show')){
						currentDropdown.classList.remove("show");
					}
					else{
						currentDropdown.classList.add("show");
					}
				}, 100)
			},

			handleOnScroll(){
				let currentScroll = document.documentElement.scrollTop || document.body.scrollTop

				if(!this.blockTimeout){
					setTimeout(() => {
						this.postScrollAnimation(currentScroll)
					}, 400);
				}

				this.blockTimeout = true
			},

			postScrollAnimation(lastScroll){
				let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
				let elem = document.querySelector('.navbar')
				// Get height of navbar and current Y position
				let max = Math.max( elem.scrollHeight, elem.offsetHeight, elem.clientHeight) + elem.getBoundingClientRect().top

				// If current scroll position is bellow the navbar initial position, hide it with fade away
				if (currentScroll != lastScroll){
					this.hideOnScroll = currentScroll > 0 && currentScroll >= max && lastScroll < currentScroll

					// Block postScrollAnimation triggered after several scrolls
					// this will avoid unwanted hide/display actions
					this.blockTimeout = false
				}
			},

		},

		beforeDestroy() {
			window.removeEventListener('resize', this.getWindowWidth);
			window.removeEventListener('resize', this.getWindowHeight);
			window.removeEventListener('scroll', this.handleOnScroll);
		}
	}
</script>
